import { apiPaths, queryKeyWithNpsn } from 'api/kinerja/kepala-sekolah/config'
import { useKinerjaApi } from 'api/kinerja/utils/api'

import type { UseQueryOptions } from 'react-query'
import type { CommonResponse } from 'types/api'

type EvaluationResultData = {
  namaInstansi: string
  ks: {
    nama: string
    nip: string
    pangkatGolongan: string
    jabatan: string
    unitKerja: string
  }
  dinas: {
    nama: string
    nip: string
    pangkatGolongan: string
    jabatan: string
    unitKerja: string
  }
  predikatKinerja: {
    praktikKinerja: string
    perilakuKerja: string
    predikatKinerja: string
    poinPengembanganKompetensi: number
  }
}

const API_GET_KS_EVALUATION_RESULT_QUERY_KEY =
  'API_GET_KS_EVALUATION_RESULT_QUERY_KEY'

export function useApiGetEvaluationResult(
  npsn: string,
  opts?: UseQueryOptions<CommonResponse<EvaluationResultData>>
) {
  return useKinerjaApi<CommonResponse<EvaluationResultData>>(
    `${apiPaths.penilaian}/result`,
    {
      axiosConfig: { params: { npsn } },
      queryConfig: { useErrorBoundary: false, ...opts },
      queryKey: queryKeyWithNpsn(API_GET_KS_EVALUATION_RESULT_QUERY_KEY, npsn),
    }
  )
}
